$(function () {
    $('a[href^="#"]').click(function () {
        let href = $(this).attr("href");
        let target = $(href == "#" || href == "" ? 'html' : href);
        let position = target.offset().top;
        $("html, body").animate({ scrollTop: position }, 550, "swing");
        return false;
    });

    $(".js_accordion").on("click", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("is_accordion--active");
        return false;
    });

    const scrollTarget = $('.js_inshow');
    if (scrollTarget.length) {
        scrollAnimation();
    }
    function scrollAnimation() {
        $(window).scroll(function () {
            scrollTarget.each(function () {
                let position = $(this).offset().top,
                    scroll = $(window).scrollTop(),
                    windowHeight = $(window).height();

                if (scroll > position - windowHeight) {
                    $(this).addClass('is_show');
                }
            });
        });
    }
    $(window).trigger('scroll');
});

